import React from "react";
import PropTypes from "prop-types";
import Stepper from "@mui/material/Stepper";
import Step from "@mui/material/Step";
import StepLabel from "@mui/material/StepLabel";
import { useStepper } from "./context";
function Steps({ steps }) {
  const { activeStep, handleStep } = useStepper();
  return (
    <Stepper activeStep={activeStep} orientation="vertical">
      {steps.map((step, index) => (
        <Step key={step.label + index}>
          <StepLabel 
          //onClick={() => handleStep(index)}
          >{step.label}</StepLabel>
        </Step>
      ))}
    </Stepper>
  );
}

Steps.propTypes = {
  steps: PropTypes.arrayOf(
    PropTypes.shape({
      label: PropTypes.string.isRequired,
    })
  ).isRequired,
};

export default Steps;
